import { listKeys, readJson, writeJson } from "./storage";

// Read endpoints that are safe to serve from the last good response while
// offline. Anything not listed here (carts, drafts, pins, chat) always needs
// the server.
const CACHEABLE = [
  "products",
  "categories",
  "customers",
  "payment-methods",
  "receipt-template",
  "orders/auto-bill",
  "currency-settings",
];

export const isCacheable = (url) =>
  CACHEABLE.some((p) => url === p || url.startsWith(`${p}?`) || url.startsWith(`${p}/`));

const keyFor = (url) => `read:${url}`;

export const saveRead = (url, value) => {
  if (isCacheable(url) && value !== undefined) writeJson(keyFor(url), value);
};

export const loadRead = (url) => readJson(keyFor(url), undefined);

// A product search while offline: cached pages are searched client side.
export const searchCachedProducts = (search) => {
  const needle = String(search || "").trim().toLowerCase();
  const seen = new Map();
  listKeys("read:products?page=").forEach((key) => {
    if (key.includes("searchParam=")) return;
    const page = readJson(key);
    (Array.isArray(page?.data) ? page.data : []).forEach((p) => seen.set(p.id, p));
  });
  const all = [...seen.values()].filter(
    (p) => !needle || String(p.product_name || "").toLowerCase().includes(needle)
  );
  if (all.length === 0) return undefined;
  return { data: all.slice(0, 40), current_page: 1, last_page: 1, total: all.length };
};
